require('angular-material');
require('angular-material-data-table/dist/md-data-table.min.css');
require('./angularMaterial.scss');

const { palette } = require('ui/bk/base/variables');
require('../../web/base/fonts/ss-gizmo/ss-gizmo.css');

const deps = [require('angular-material-data-table'), 'ngMaterial'];

module.exports = angular
  .module('bench.ui.angularMaterial', deps)
  .config($mdThemingProvider => {
    $mdThemingProvider.definePalette('primaryBenchPalette', {
      50: palette.waterLight,
      100: palette.waterLight, // used as the disabled state in md-nav-bar
      200: palette.waterLight,
      300: palette.waterLight,
      400: palette.waterLight,
      500: palette.water,
      600: palette.waterDark,
      700: palette.waterDark,
      800: palette.waterDarkest,
      900: palette.waterDarkest,
      A100: palette.waterDark,
      A200: palette.water,
      A400: palette.water,
      A700: palette.waterLight,
      contrastDefaultColor: 'light',
      contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
      contrastLightColors: undefined,
    });

    $mdThemingProvider.definePalette('accentBenchPalette', {
      50: palette.bonsaiLight,
      100: palette.bonsaiLight,
      200: palette.bonsaiLight,
      300: palette.bonsaiLight,
      400: palette.bonsaiLight,
      500: palette.bonsai,
      600: palette.bonsaiDark,
      700: palette.bonsaiDark,
      800: palette.bonsaiDarkest,
      900: palette.bonsaiDarkest,
      A100: palette.bonsaiDark,
      A200: palette.bonsai, // used as the accent in md-nav-bar
      A400: palette.bonsai,
      A700: palette.bonsaiLight,
      contrastDefaultColor: 'light',
      contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
      contrastLightColors: undefined,
    });

    $mdThemingProvider.definePalette('warnBenchPalette', {
      50: palette.orangeLight,
      100: palette.orangeLight,
      200: palette.orangeLight,
      300: palette.orangeLight,
      400: palette.orangeLight,
      500: palette.orange,
      600: palette.orangeDark,
      700: palette.orangeDark,
      800: palette.orangeDarkest,
      900: palette.orangeDarkest,
      A100: palette.orangeDark,
      A200: palette.orange,
      A400: palette.orange,
      A700: palette.orangeLight,
      contrastDefaultColor: 'light',
      contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
      contrastLightColors: undefined,
    });

    $mdThemingProvider.definePalette('backgroundBenchPalette', {
      50: palette.neutral11,
      100: palette.neutral10,
      200: palette.neutral9,
      300: palette.neutral8,
      400: palette.neutral7,
      500: palette.neutral6, // used as the background to the disabled toggle
      600: palette.neutral5,
      700: palette.neutral4,
      800: palette.neutral3,
      900: palette.neutral2, // used for the md-dialog backdrop
      A100: palette.neutral11, // used as the main background
      A200: palette.neutral1, // used for datepicker font color
      A400: palette.neutral11,
      A700: palette.neutral11,
      contrastDefaultColor: 'dark',
      contrastDarkColors: undefined,
      contrastLightColors: ['50', '100', '200', '300', '400', 'A100'],
    });

    $mdThemingProvider
      .theme('default')
      .primaryPalette('primaryBenchPalette')
      .accentPalette('accentBenchPalette')
      .warnPalette('warnBenchPalette')
      .backgroundPalette('backgroundBenchPalette');
  })
  // configure default icon fonts for angular material
  .config($mdIconProvider => {
    $mdIconProvider.fontSet('md', 'material-icons', 'bl-icon');
  })

  .config($mdInkRippleProvider => {
    $mdInkRippleProvider.disableInkRipple();
  });
